<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew && $check(user, ['reporttypes.create'])" type="button" elevation="0"
                            color="primary" @click=create()>Salvar</v-btn>
                        <v-btn v-if="!page.isNew && $check(user, ['reporttypes.update'])" type="button" elevation="0"
                            color="primary" @click=update()>Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/modelo-relatorio">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense id="name" label="Nome" v-model="dataset.data.name"
                                                required :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-row text-align="center">
                                    <v-col cols="12">
                                        <v-card class="card-form-outlined">
                                            <v-row justify="center" align="center">
                                                <v-col>
                                                    <v-card-title class="card-group-title">Colunas</v-card-title>
                                                </v-col>
                                                <v-spacer></v-spacer>
                                                <v-col align="end">
                                                    <v-btn class="mr-4" type="button" outlined elevation="0"
                                                        color="primary" @click="addColumn()">Adicionar</v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-card-text v-if="dataset.data.columns.length">
                                                <template>
                                                    <v-container fluid class="pa-0 ma-0">
                                                        <div v-for="(item, index) in dataset.data.columns" :key="index">
                                                            <v-row align="center">
                                                                <v-col cols="12" sm="4">
                                                                    <v-text-field dense id="label" label="Nome"
                                                                        v-model="item.label" required
                                                                        :rules="[$rules.required]" outlined
                                                                        hide-details="auto"
                                                                        :disabled="item.id && !page.isNew">
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <v-text-field dense id="key" label="Chave"
                                                                        v-model="item.key" required
                                                                        :rules="[$rules.required]" outlined
                                                                        hide-details="auto"
                                                                        :disabled="item.id && !page.isNew">
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col cols="12" :sm="page.isNew ? 3 : 4">
                                                                    <v-select dense :items="dataset.reportColumnTypes"
                                                                        :rules="[$rules.required]" required label="Tipo"
                                                                        v-model="item.type" item-value="id"
                                                                        item-text="name" outlined hide-details="auto"
                                                                        :disabled="item.id && !page.isNew">
                                                                    </v-select>
                                                                </v-col>
                                                                <v-col v-if="page.isNew" cols="12" sm="1">
                                                                    <v-tooltip bottom>
                                                                        <template #activator="{ on }">
                                                                            <v-icon @click="removeColumn(index)" icon
                                                                                v-on="on" size="x-large" color="error">
                                                                                mdi-close
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Remover coluna</span>
                                                                    </v-tooltip>
                                                                </v-col>
                                                            </v-row>

                                                            <v-divider class="my-4"></v-divider>

                                                        </div>
                                                    </v-container>

                                                </template>
                                            </v-card-text>
                                            <v-card-text v-else>
                                                Nenhuma coluna adicionada.
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <v-row text-align="center">
                                    <v-col cols="12">
                                        <v-card class="card-form-outlined">
                                            <v-card-title class="card-group-title">Regras</v-card-title>
                                            <v-card-text>
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <v-select dense :items="getColumnsRules()" item-value="id"
                                                            item-text="label" v-model="rule.column1" label="Coluna 1"
                                                            outlined hide-details="auto"></v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="2">
                                                        <v-select dense :items="operators" v-model="rule.operator"
                                                            label="Operador" outlined hide-details="auto"></v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-select dense :items="getColumnsRules()" item-value="id"
                                                            item-text="label" v-model="rule.column2" label="Coluna 2"
                                                            outlined hide-details="auto"></v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="2">
                                                        <v-btn color="primary" @click="addRule">Adicionar</v-btn>
                                                    </v-col>
                                                </v-row>
                                                <v-divider class="my-4"></v-divider>
                                                <v-list v-if="dataset.data.rules.length">
                                                    <v-list-item-group>
                                                        <v-list-item v-for="(item, index) in dataset.data.rules"
                                                            :key="index">
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ item.column1 }} {{ item.operator
                                                                    }} {{ item.column2
                                                                    }}</v-list-item-title>
                                                            </v-list-item-content>
                                                            <v-list-item-action>
                                                                <v-icon color="error"
                                                                    @click="removeRule(index)">mdi-close</v-icon>
                                                            </v-list-item-action>
                                                        </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                                <v-card-text v-else>Nenhuma regra adicionada.</v-card-text>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>

                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import axios from "axios"

import reportColumnTypes from '@/common/data/report-column-types.data'

export default {
    name: "ReportTypeDetails",

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        rule: {
            column1: '',
            operator: '',
            column2: ''
        },
        operators: ['+', '-', '*', '/'],
        dataset: {
            reportColumnTypes: reportColumnTypes,
            breadcrumbItems: [],
            loading: false,
            data: {
                columns: [],
                rules: []
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
        },
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData();
    },

    methods: {

        goBack() {
            this.$router.replace("/modelo-relatorio");
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page && this.page.isNew ? "Criar modelo" : "Detalhes do modelo";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Modelos de Relatórios",
                disabled: false,
                to: "/modelo-relatorio",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/report-types/${this.$route.params.id}`);

                this.dataset.data = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do modelo?',
                title: 'Atualizar modelo',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar',
                },
            });

            if (!proceedAction) return;

            const payload = await this.buildPayload();

            console.log("payload: ", payload)

            try {
                const response = await axios.patch(`/api/admin/report-types/${this.$route.params.id}`, payload, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Modelo atualizado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                this.$dialog.notify.error('Erro ao atualizar o modelo.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        async create() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja criar um novo modelo?',
                title: 'Criar modelo',
                actions: {
                    false: 'Cancelar',
                    true: 'Criar',
                },
            });

            if (!proceedAction) return;

            const payload = await this.buildPayload();

            try {
                const response = await axios.post('/api/admin/report-types', payload, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Modelo criado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                // TODO: melhorar
                this.$dialog.notify.error('Erro ao criar o modelo.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },


        async buildPayload() {
            return {
                name: this.dataset.data.name,
                columns: this.dataset.data.columns,
                rules: this.dataset.data.rules
            };
        },

        getColumnsRules() {
            return this.dataset.data.columns.filter((x) => x.id && x.type == 4);
        },

        async delete() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja excluir o cargo e desvincular todos os usuários a ele?',
                title: 'Excluir cargo',
                actions: {
                    false: 'Cancelar',
                    true: 'Criar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/role/delete', payload, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.$dialog.notify.info("Cargo excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        addColumn() {
            this.dataset.data.columns.push({ key: '', label: '', type: 1 })
        },

        removeColumn(index) {
            this.dataset.data.columns.splice(index, 1)
        },

        addRule() {
            if (this.rule.column1 && this.rule.operator && this.rule.column2) {
                this.dataset.data.rules.push({ ...this.rule });
                this.rule = { column1: '', operator: '', column2: '' };
            }
        },

        removeRule(index) {
            this.dataset.data.rules.splice(index, 1);
        }

    },


};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.main-text {
    font-size: 16px;
    color: #000;
}

.caption-text2 {
    font-size: 12px;
    font-weight: bold;
    color: #444;
    margin-top: -5px;
}
</style>